import React, { useEffect } from "react";
import Sidebar from "../Sidebar/Sidebar";

const Shell = ({ ShellNavMenuEntries, onOpenUserModal, onOpenLinkPortalModal, colorStatusPairing, iconStatusPairing, children, userAvatar, ShellHeaderLogo }) => {
    const [isSideBarOpen, setSideBarOpen] = React.useState(true);
    const [isSideBarHover, setSideBarHover] = React.useState(false);
    // For detect state change (grow-up <-> minify)
    const [prevState, setPrevState] = React.useState(true);
    const [animating, setAnimating] = React.useState(false);

    const drawerWidth = 213;
    const minDrawerWidth = 84;

    // Animation for opening (grow-up): Bounce to the right
    const expandKeyframes = `
        @keyframes expandSideBar {
            0% { width: ${minDrawerWidth}px; }
            70% { width: ${drawerWidth + 10}px; }
            100% { width: ${drawerWidth}px; }
        }
    `;

    // Animation for closing (minify): Bounce to the left
    const collapseKeyframes = `
        @keyframes CollapseSideBar {
            0% { width: ${drawerWidth}px; }
            70% { width: ${minDrawerWidth - 10}px; }
            100% { width: ${minDrawerWidth}px; }
        }
    `;


    // Inject keyframes in the head
    useEffect(() => {
        const styleEl = document.createElement("style");
        styleEl.id = "dynamic-keyframes";
        styleEl.innerHTML = expandKeyframes + collapseKeyframes;
        document.head.appendChild(styleEl);
        return () => {
            document.head.removeChild(styleEl);
        };
    }, [collapseKeyframes, drawerWidth, expandKeyframes, minDrawerWidth]);

    // When animation finished, stop animation and fix final width
    const handleAnimationEnd = () => {
        setAnimating(false);
        setPrevState(isSideBarOpen);
    };

    return <>
        <div style={{
            height: "100vh",
            display: "flex",
            flexDirection: "row",
            width: "100vw" }}
        >
            <div className="SideBarContainer" style={{
                position: "relative",
                width: animating
                    ? undefined
                    : isSideBarOpen
                        ? `${drawerWidth}px`
                        : `${minDrawerWidth}px`,
                animation: animating ? `${animating} 0.5s forwards` : "none"
            }}
            onAnimationEnd={handleAnimationEnd}
            >
                <Sidebar
                    ShellHeaderLogo={ShellHeaderLogo}
                    userAvatar={userAvatar}
                    minify={!isSideBarOpen}
                    entries={ShellNavMenuEntries}
                    onOpenSideBar={(open) => {
                        if (open !== isSideBarOpen) {
                            setSideBarOpen(open);
                            if (prevState !== open) {
                                setAnimating(open ? "expandSideBar" : "CollapseSideBar");
                            }
                        }
                    }}
                    onOpenUserModal={onOpenUserModal}
                    onOpenLinkPortalModal= {onOpenLinkPortalModal}
                    colorStatusPairing={colorStatusPairing}
                    iconStatusPairing={iconStatusPairing}
                />

            </div>
            <div className="AppPagesContainer" style={{ width: "calc(100vw - " + (isSideBarOpen ? drawerWidth : minDrawerWidth) + "px)" }} >
                {children}
            </div>
        </div>
    </>;
};

export default Shell;
